import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import providerData from "../../ProviderServices.json";
import {
  clearEventServiceData,
  setEventServiceData,
} from "../../store/eventServiceSlice";

const ShowButtonToEventServices = ({ eventId, cartData, eventDetails }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log("ShowButtonToEventServices eventId",eventId,"cartData",cartData,"eventDetails",eventDetails)
  if (!eventDetails || !cartData || !cartData[eventId]) return null;

  const {
    priestData = [],
    tentHouseData = [],
    cateringData = [],
  } = cartData[eventId] || {};
  let selectedService = null;

  const isPriestRequired =
    eventDetails?.eventMasterDetails?.is_priest_required !== false;

  if ((!priestData || priestData.length === 0) && isPriestRequired) {
    selectedService = providerData.find((item) => item.id === 7);
  } else if (!tentHouseData || tentHouseData.length === 0) {
    selectedService = providerData.find((item) => item.type === "Rentals");
  } else if (!cateringData || cateringData.length === 0) {
    selectedService = providerData.find((item) => item.type === "Catering");
  } else {
    // Catering exists, but we want to allow adding more
    selectedService = providerData.find((item) => item.type === "Catering");
  }

  if (!selectedService) return null;

  const handleClick = () => {
    const info = {
      serviceDetails: selectedService,
      eventDetails: eventDetails,
    };
    console.log("foundid", info);
    dispatch(clearEventServiceData());
    dispatch(setEventServiceData(info));
    navigate("/providers", { state: info });
    window.scrollTo({ top: 0 });
  };

  let label;
  if (selectedService.type === "Catering") {
    if (cateringData && cateringData.length > 0) {
      label = "Add more Food for same event like Breakfast/Lunch/Dinner";
    } else {
      label = "Order Catering";
    }
  } else if (selectedService.type === "Rentals") {
    label = "Rent Tenthouse";
  } else {
    label = "Book Priest";
  }
const isAddMoreCatering = 
  selectedService.type === "Catering" && cateringData && cateringData.length > 0;

const buttonClass = `go-to-event${isAddMoreCatering ? " no-style" : ""}`;
  return (
    <button className={buttonClass} onClick={handleClick}>
      {label}
    </button>
  );
};

export default ShowButtonToEventServices;
